import React from "react";
import UserContext, { IUserData } from "components/Users/UserSetupContext";

export function useUserData(): IUserData {
    const userData = React.useContext(UserContext);
    return userData;
};

export default useUserData;
